<template>
  <div>
    <h3 class="page-header">Typography and Texts</h3>
    <h1 class="pb-10">Lato (Google font)</h1>
    <div class="row">
      <div class="col-md-6">
        <p>Normal 400</p>
        <p class="is-bold">Bold 700</p>
        <p class="pwave-alphabet">
          ABCDEFGHIJKLMNOPQRSTUVWXYZ
        </p>
        <p class="pwave-alphabet">
          abcdefghijklmnopqrstuvwxyz
        </p>
        <p class="pwave-alphabet">
          1234567890-=_+*&$#@!";:,.<>()
        </p>
        <p class="pt-15">
          font-family: 'Lato', sans-serif;
        </p>
        <p>
          letter-spacing: 1px;
        </p>
      </div>
      <div class="col-md-6">
        <h1>h1 Heading 36px</h1>
        <h2>h2 Heading 30px</h2>
        <h3>h3 Heading 24px</h3>
        <h4 class="pb-15">h4 Heading 18px</h4>
        <p>
          A mad boxer shot a quick, gloved jab to the jaw of his dizzy opponent.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/assets/components/PwTypography.vue